import React from 'react';
import { map, isArray, split } from 'lodash';

const ServiceGrid = props => {
  const { resources } = props;
  const serviceGrid = () => {
    return map(resources, (item, index) => {
      const renderPhone = () => {
        if (isArray(item.phone) && item.phone.length > 1) {
          return (
            <span>
              <a href={`tel:+1-${split(item.phone[0], ' ').join('-')}`}>
                {split(item.phone[0], ' ').join('-')}
              </a>{' '}
              or{' '}
              <a href={`tel:+1-${split(item.phone[1], ' ').join('-')}`}>
                {split(item.phone[1], ' ').join('-')}
              </a>
            </span>
          );
        }
        return (
          <span>
            <a href={`tel:+1-${split(item.phone, ' ').join('-')}`}>
              {item.phone[0] === '8'
                ? `1 ${split(item.phone, ' ').join('-')}`
                : split(item.phone, ' ').join('-')}
            </a>
          </span>
        );
      };

/*
      let website = '';
      if (item.website) {
        if (item.website.includes("https://")) {
          website = item.website;
        } else if (item.website.includes("http://")) {
          website = item.website;
        } else {
          website = `http://${item.website}`;
        }
      }
*/
	  
	const getWebsitesHTML= (websites) => {
	
	//	return (<a href="hello.com" target="_blank">{websites.join(', ')}</a>);

		let websitesHTML =  map(websites, (websiteItem, websiteIndex) => {

			let website = '';

			if (websiteItem) {
				if (websiteItem.includes("https://")) {
					website = websiteItem;
				} else if (item.website.includes("http://")) {
					website = websiteItem;
				} else {
					website = `http://${websiteItem}`;
				}
			}


			return ( 
				<React.Fragment key={websiteIndex}>
					{ (websiteIndex !== 0) && <br/> }
					<a
					style={{ wordWrap: 'break-word' }}
					href={website}
					target="_blank"
					>{website}</a>
				</React.Fragment>
			);
		});
		
		return websitesHTML;
	};

	let websiteHTML = '';
	if(typeof item.website == 'string'){
		websiteHTML = getWebsitesHTML([item.website]);	
	}else{
		websiteHTML = getWebsitesHTML(item.website);	
	}

      return (
        <div key={`${item.title}_${index}`} className="grid-item">
          <div className="grid-item-info">
            <h3>{item.title}</h3>
            <br />
            {item.phoneNode ? item.phoneNode : renderPhone()}
            {item.phone && <br />}
            {item.hours}
            {item.hours && <br />}
            {item.location}
            {item.location && <br />}
			{websiteHTML}
          </div>
          <p>{item.descriptionNode ? item.descriptionNode : item.description}</p>
        </div>
      );
    });
  };
  return <div className="service-grid-container">{serviceGrid()}</div>;
};

export default ServiceGrid;



// WEBPACK FOOTER //
// ./src/components/ServiceGrid/index.jsx